import React from "react";
import { Row, Col, Input, Select } from "antd";

const { Option } = Select;

/**
 * ForteBankPayment - eCheck payment component for Forte processor
 * Uses local state props for routing/account numbers that are tokenized via Forte API
 */
const BankPayment = (props) => {
  const {
    routingNumber,
    setRoutingNumber,
    accountNumber,
    setAccountNumber,
    accountType,
    setAccountType,
    errorField = [],
    setErrorField,
  } = props;

  // Ensure errorField is always an array
  const safeErrorField = Array.isArray(errorField) ? errorField : [];

  return (
    <div className="block">
      <Row gutter={16}>
        <Col xs={24} sm={10}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Routing Number*</div>
          <Input
            value={routingNumber || ""}
            className={
              safeErrorField.includes("routingNumber")
                ? `common-input-error`
                : `common-input`
            }
            onChange={(e) => {
              if (setErrorField && safeErrorField.includes("routingNumber")) {
                const errors = safeErrorField.filter((x) => x !== "routingNumber");
                setErrorField([...errors]);
              }
              setRoutingNumber(e.target.value);
            }}
          />
        </Col>
        <Col xs={24} sm={10}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Account Number*</div>
          <Input
            value={accountNumber || ""}
            className={
              safeErrorField.includes("accountNumber")
                ? `common-input-error`
                : `common-input`
            }
            onChange={(e) => {
              if (setErrorField && safeErrorField.includes("accountNumber")) {
                const errors = safeErrorField.filter((x) => x !== "accountNumber");
                setErrorField([...errors]);
              }
              setAccountNumber(e.target.value);
            }}
          />
        </Col>
        <Col xs={24} sm={4}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Account Type</div>
          <Select
            className="common-select"
            value={accountType || "c"}
            style={{ width: "100%" }}
            onSelect={(v) => {
              setAccountType(v);
            }}
          >
            <Option value="c">Checking</Option>
            <Option value="s">Savings</Option>
          </Select>
        </Col>
      </Row>
    </div>
  );
};

export default BankPayment;
